export default {
  bank_product: {
    complete_msg:
      '我們衷心感謝您<span>訂閱該產品</span>，我們將以更好的產品回報您。',
  },
  enter_amount: '請輸入金額。',
  reg_complete: '註冊完成',
  subscription_details: '訂閱詳情',
  select_withdrawal_account: '選擇提款賬戶',
  email_address: '電子郵件地址',
  product_info: '產品信息',
  new_amount: '新金額',
  min_running_amount: '最低執行量 ',
  max_running_amount: '最大執行量 ',
  product_type: '產品類別',
  bank_product_name: '商品名',
  reg_start_date: '註冊開始日期',
  reg_end_date: '訂閱結束日期 ',
  exec_start_date: '開始執行的日期 ',
  exec_end_date: '執行結束日期 ',
  basic_info: '基本信息',
  not_applicable: '不適用',
  subscription: '加入',
  service_prepare: '正在準備服務。',
  no_buy_list: '没有购买记录。',
  no_sell_list: '没有销售记录。',
  no_list: '沒有清單。',
  locale_name: '中文(臺灣)',
  Sale_registration: '銷售登記',
  apply: '申請',
  status: '狀態',
  wallet: '錢包',
  wallet_address: '錢包地址',
  wallet_transfer: '錢包轉賬',
  buy: '購買',
  sell: '出售',
  all: '所有',
  breakdown: '記錄',
  act_buy: '購買',
  act_sell: '出售',
  asset: '資產',
  select: '選擇',
  no_select: '沒有選擇',
  account: '帳戶',
  balance: '餘額',
  login: '登錄',
  logout: '退出',
  register: '註冊',
  select_cancel: '取消選中',
  cancel: '取消',
  modify: '編輯',
  auto_input: '(自動輸入)',
  confirm: '確認',
  look_up: '查詢',
  password: '密码',
  account_delete: '取消訂閱',
  detail: '詳細信息',
  list_detail: '詳細信息',
  birth: '生日',
  welcome: '歡迎',
  please_login: '請登錄',
  confirmation_login: '您可以在登錄時進行檢查。',
  id: 'ID',
  find_id: '查找ID',
  find_password: '查找密碼',
  back: '返回',
  agreement: '協議',
  info_input: '輸入信息',
  success: '完成',
  all_agree: '同意所有條款',
  agree: '同意',
  agreed: '同意',
  confirm_password: '確認密碼',
  repeat_password: '請重新輸入密碼',
  next: '下一步',
  before: '回去',
  register_success: '您已註冊',
  verify: '驗證',
  retention: '保留',
  allow: '(允許)',
  disallow: '(不允許)',
  upload_btn: '請在此處刪除或單擊文件。',
  continue_entry: '請在下面輸入“ [+:verification]”以繼續',
  login_msg_1: '在 ONETETHER上嘗試一個與硬幣相關的帳戶 ！',
  login_msg_2: '請通過我們的ONETETHER使用交易，錢包和服務。',
  login_msg_3: 'ONETETHER支持所有環境',
  cocofx_register: '註冊ONETETHER',
  register_msg_1: '開始註冊<br />請同意服務條款',
  register_msg_3: '用ONETETHER賬戶可以簡單的使用所有服務',
  register_msg_all:
    '全部同意包括對必選及選擇項目的同意，也可以個別選擇同意。拒絕對選擇項目同意時，服務也可以使用',
  register_title: '滿19周歲以上',
  register_title_2: 'ONETETHER條款',
  register_title_3: 'ONETETHER集成服務條款',
  register_title_4: 'ONETETHER營銷槓桿同意',
  register_title_5: '同意收集和使用個人信息',
  register_title_6: '同意收集和使用位置信息',
  register_title_7: '同意收集其他個人資料信息',
  register_title_8: '請輸入ONETETHER帳戶信息',
  register_title_9: '輸入信息',
  register_msg_4:
    '這些條款適用於公司提供的所有服務等。<br />接受這些條款，您可以使用這些服務而無需簽訂單獨的合同。',
  required: '[必選]',
  option: '[選擇]',
  otp_notice: '狀態被激活和停用OTP不可能的。',
  required_check: '請檢查所有必填字段',
  check_input: '請輸入所有的細節。',
  register_guide: '如何使用ONETETHER',
  register_step1: 'COCO點擊付款按鈕',
  register_step2: '登錄COCO收費',
  register_step3: '支付/充值ONETETHER登錄',
  copy: '複製',
  no_account: '沒有註冊的帳戶。',
  inviter_link: '推薦人鏈接',
  exchange: '貨幣兌換',
  register_used_account: '註冊經常使用的賬戶',
  security_certification: '安全認證',
  admin_security: '{action}的安全等級是{limit}',
  company: '企業',
  exact_calculation: '調整',
  profile: '會員資料',
  inquiry: '查詢',
  inquiry_history: '諮詢記錄',
  announcement: '通知',
  information: '信息',
  history: '歷史',
  registration_date: '登錄日',
  pay: '付款',
  detail_search: '詳細搜索',
  more_view: '詳細查看',
  exchange_store: '交易所',
  external_exchange_store: '外部交易所',
  internal_exchange_store: '內部交流',
  external_transaction: '對外交易',
  internal_transaction: '內部交易',
  favorites: '收藏夾',
  no_favorite_list: '沒有收藏夾。',
  no_alias: '沒有別名',
  please_enter_account_name: '請輸入您的帳戶名。',
  variable_amount: '變動金額',
  changes: '變動記錄',
  account_transaction_history_inquiry: '賬戶交易記錄查詢',
  exchange_application_completed: '貨幣兌換申請已經完成。',
  choose_how_pay_fee: '選擇手續費支付方法',
  free: '免費',
  closing: '閉幕',
  relative_asset_inquiry: '相對資產查詢',
  please_enter_relative_account_number: '請輸入相對帳號。',
  Please_enter_relative_wallet_address: '請輸入相對的錢包地址。',
  memo: '備忘錄',
  write_history_memo: '請記錄備忘錄便於管理',
  re_enter: '重新輸入',
  transfer_wallet_account: '轉賬錢包地址',
  transfer_wallet_inquiry: '匯款錢包查詢',
  Kiosk: '自助式服务',
  withdrawable_amount: '可取款金額',
  transferred_assets: '資產轉賬',
  recipient: '收件人',
  recipient_wallet: '收件人',
  register_user_name_tit: '我們建議您填寫安全認證的真實姓名。',
  register_password_tit: '請正確填寫常用的電子郵件地址。',
  product_name: '商品名',
  dividend_type: '分紅型',
  auto: '自動的',
  manual: '手動的',
  s_usdt_protocol: '選擇泰德協議',
  ccf: {
    what_ccf: 'CCF是什麼?',
    key_coin: '將加密貨幣與真實貨幣聯繫起來的COCOBNAK的主要硬幣',
    ccf_description:
      '將多種加密貨幣通過直接兌換和C2C交易換算的ONETETHER獨有的主要貨幣,1CCF的價值為USD 1CENT.CCF可以在ONETETHER中更快，更安全地進行購買和交易.',
    how_use_ccf: '怎麼使用CCF?',
    cocobank_wallet_transfer:
      '將存儲在外部交易所的加密貨幣資產轉移到ONETETHER的錢包.',
    ccf_conversion: '將轉移到錢包的加密貨幣通過直接兌換或C2C交易轉換為CCF.',
    direct_exchange_c2c_deal: '直接兌換C2C交易',
    ccf_moved: '將轉換的CCF轉移到ONETETHER賬戶.',
    how_use_account_ccf: '請這樣使用轉移到賬戶的CCF!',
    freely_purchase_open_market: '請用CCF自由的購買OPEN MARKET的商品吧!',
    free_deposit_withdrawal: '銀行內賬戶可以自由存取款和轉賬!',
    exchange_currencies_convenient:
      '通過直接兌換和C2C交易，貨幣之間的交換變得很方便!',
    offline_convenient: '即使離線也可以更方便地使用COCOBANGK的服務!',
    how_wallets_accounts_different: '錢包和賬戶有什麼不同?',
    same_means_storing_cryptocurrency:
      '雖然在ONETETHER中錢包和賬戶是存儲加密貨幣的相同方法，但是根據加密貨幣交易的類型（內外部）的不同，，其使用方式也不同。也就是說，錢包用於交易所和ONETETHER之間的交易（外部），而帳戶則用於ONETETHER中的交易（內部）.',
  },
  header: {
    inquiry_history: '諮詢記錄',
    certification_management: '認證/管理',
    c2c_enroll: '購買/銷售註冊',
    wallet_list: '錢包/歷史記錄查詢',
    wallet: '錢包',
    c2c_list: '購買/出售記錄',
    no_c2c_sell_list: '沒有銷售記錄。',
    transfer_list: '兌換記錄',
    no_transfer_list: '沒有兌換內容',
    withdrawal_list: '存/取款記錄',
    my_info: '我的信息',
    home: '主要',
    payment_history: '帳單紀錄',
    account_transfer: '轉賬',
    transfer_history: '轉賬明細',
    register_used_account: '註冊經常使用的賬戶',
    exchange: '直接兌換',
    exchange_list: '兌換明細',
    email: '電子郵件',
    email_list: '電子郵件歷史記錄',
    otp: 'OTP',
    otp_list: 'OTP歷史',
    register_account: '註冊帳號',
    calculation_account_list: '結算清單',
    security_certification: '安全認證',
    exact_calculation: '調整',
    history: '歷史',
    coco_open_market: 'COCO公開市場',
    information: '信息',
    my_profile: '我的信息',
    email_modify: '編輯電子郵件',
    password_modify: '修改密碼',
    inquiry: '查詢',
    one_on_one_inquiry: '1：1諮詢',
    frequently_asked_questions: '常問問題',
    announcement: '通知',
    notice: '公告',
    server_notice: '伺服器公告',
    service_center: '服務中心',
    profile: '會員資料',
    company: '企業',
    account_management: '賬戶管理',
    do_exchange: '為了交換',
    transfer: '轉賬',
    look_up: '查詢',
    faq: '常問問題',
    server: '服務器',
    email_auth: '電子郵件認證',
    email_request: '電子郵件聯繫',
    Product_Subscription: '商品&加入',
    easy_payment: '輕鬆付款',
    easy_login: '輕鬆登錄',
  },
  footer: {
    footer_msg: '請在ONETETHER上使用與COIN相關的賬號！',
    footer_sub_msg: '"請通過我們的ONETETHER使用交易，錢包和服務',
    footer_sub_msg2: '提示',
    footer_sub_msg3: 'ONETETHER支持所有環境',
    ICO: 'ICO',
    c2c: 'C2C交易所',
    b2c: 'B2C交易所',
    margin_exchange: '保證金交易所',
    gift_exchange: '期貨交易所',
    Binary: '二元期權',
    open_marcket: '公開市場',
    game: '遊戲',
    proceed: '正在進行的交易',
    public: '已列出',
    direct_ex: '直接兌換',
    buy: '買入',
    sell: '賣出',
    buy_sell: '买/卖',
    holding_coin: '持有硬幣',
    fee: '費用信息',
    exchange: '交易所',
    transfer_record: '交易記錄',
    Leverage: '槓桿',
    live_exchange: '實時交易',
    demo_exchange: '模擬交易',
    contest: '競賽',
    powerball: '強力球',
    law:
      '法律：ONETETHER.COM 登錄號碼：70638826927（U 6 29 Railway Pde EastwoodNSW 2122）',
    law1:
      'Trading Point of Financial Instruments Ltd（澳大利亞）的全部所有者ONETETHER PTY Ltd登錄號碼：70638826927商號。',
    law2:
      '該網站由ONETETHER Corp運營。ONETETHER Corp的批准號碼為64190-由Auxiliary finance service制約，參考號碼為70638826927在澳大利亞登錄。',
    law3: 'ONETETHER是根據澳大利亞金融商品投資方針運營的。',
    law4:
      'ref. no. 538324 | ABN reg. 70638826927 | BA reg. 64190. 在居住國家的法律規定中，確認ONETETHER服務是否允許使用是顧客的責任。',
    law5: '請閱讀ONETETHER的危險公示專文。',
    law6:
      'ONETETHER不為美國、貝里斯、模里西斯、日本、阿爾伯塔、英屬哥倫比亞、魁北克、薩斯喀徹、海地、蘇利南、北韓、波多黎各和塞普勒斯佔領地區的居民提供服務。',
    law7: '詳細內容請參考常問問題制約部分。請參考我們的風險公示',
    law8:
      '限制地區：Trading Point of Financial Instruments Ltd不向第三世界國家地區提供投資和附加服務。',
    law_warn: '風險提示：',
    law_1:
      'CFD具有高風險和複雜的產品，由於槓桿作用會有很大的風險。個人投資者69.10％中CFD交易時，都會虧錢。',
    law_2:
      '您必須考慮是否能接受和理解CFD的運行方式，擁有較高賠錢的風險。請參考我們的風險公示。',
    alert_title: '注注和',
    coco_market: 'COCOMARKET',
    ieo_market: 'IEO市場',
    news: '新聞',
    event: '活動',
    platform_rental_title: '平台出租',
    education: '教育',
    online_Academy: '線上學院',
    offline_Academy: '離線學院',
    shopping_basket: '購物車',
    best_product: '更多特價',
    order: '訂購',
    my_page_title: '我的頁面',
    member_info_management: '會員信息管理',
    order_management: '訂單管理',
    my_question: '我的問題',
    one_enquiry: '1：1諮詢',
    community: '社區',
    lotto: '樂透型彩票',
    rock_event: '剪刀石頭布',
    quiz_game: '答題遊戲',
    ladder_game: '梯子遊戲',
    tetris: '俄羅斯方塊',
    split_lotto: '分享彩票',
    day_Lottery: '一日彩票',
    attendance: '簽到',
    scoop_out: '轉發',
    forum: '論壇',
  },

  main_msg: {
    about_1_title: '全球最佳加密貨幣交易服務',
    about_1_msg: 'ONETETHER領導與硬幣有關的所有服務。',
    about_1_1_msg: '您可以在世界上第一次在一個地方買賣加密貨幣硬幣。',
    about_1_2_msg: '至於直接交換它是在ONETETHER。',
    about_2_title: '即時交換系統',
    about_2_msg:
      'ONETETHER使用穩定的多重並行匹配技術 先進的設計技術可實現即時交換 我有貨幣兌換系統',
    about_3_title: '創建錢包',
    about_3_msg:
      'ONETETHER由韓國最好的安全專家組成 為WALLET系統提供高級安全系統。',
    about_4_title: '簡易交易系統 （C2C）',
    about_4_msg: 'ONETETHER建立了一個用戶友好的簡易交易系統 讓交易變得更容易。',
    c2c_main_msg1_1: 'ONETETHER將立即交換使用可靠的多機並聯匹配技術',
    c2c_main_msg1_2: '握住交換系統，運用先進的設計技術，使和',
    c2c_main_msg1_3: '有。',
    c2c_main_msg2_1: '安全專家已經ONETETHER是由韓國最好的工程師',
    c2c_main_msg2_2: '配備了國家的最先進的安全系統提供電子錢包系統。',
    c2c_main_msg3_1: 'ONETETHER更容易建立人性化的交易系統',
    c2c_main_msg3_2: '它可以很容易地交易。',
  },
  toasted_msg: {
    agree_required_term: '請同意所需的條款和條件',
    must_read_term: '請閱讀或下載全部條款',
    confirm: '已確認',
    changed: '更改',
    withdrawal: '已停用',
    register: '已注册',
    delete: '它已被刪除。',
    title: '通知',
    exchange: '直接貨幣已成功處理。',
    search: '已查看',
    deposit_request: '您的存款請求',
    withdraw_request: '要求提款',
    create_account: '以開戶',
    modify: '修改',
    cancel: '取消',
    trade_confirm: '交易已確認。',
    trade_reject: '交易被拒絕。',
    copy: '已復制',
    nice_msg: '如果您的瀏覽器設置不允許彈出窗口，則身份驗證將無法正常進行。',
    nice_title: '指南',
    nice_success: '您的認證成功。',
    nice_error: '我無法驗證自己的身份。',
    no_transfer: '沒有交換信息',
    email_auth: '電子郵件驗證成功完成',
    email_auth_send: '驗證電子郵件已發送',
    kyc_withdraw: '帳戶驗證成功',
    not_allow_trade: '交易無效',
    id_find_mail_send: '您的電子郵件已發送。',
    duplicate_check: '重複的ID或郵件。',
    pay: '付款完畢。',
  },
  private: {
    deal_list: '銷售歷史',
    app_list: '購買歷史',
    deal_buy_asset: '要購買的資產',
    buy_price: '購買價格ㄴ',
    confirmed_source_amount: '已確認的銷售數量',
    holding_source_amount: '未承諾的銷售數量',
    potential_source_amount: '可用數量',
    direct_market: '直接兌換',
    deal_enroll: '銷售註冊',
    app_enroll: '購買註冊',
    select_market: '市場選擇',
    fee_rate: '手續費率',
    deal_info_input: '輸入銷售信息',
    deal_source_amount: '銷售數量',
    deal_price: '每件售價',
    deal_enroll_account: '待售帳戶註冊',
    account_select: '選擇帳戶',
    direct_asset_select: '請選擇要出售和購買的資產',
    please_select_asset: '請選擇資產',
    basic_rate: '目前行情',
    direct_transfer_buy: '立即購買',
    direct_transfer_sell: '立即出售',
    direct_source_amount: '兌換數量',
    direct_target_amount: '應用數量',
    direct_asset_buy: '用{0}進行購買',
    direct_asset_sell: '作為{0}出售',
    selected_deal_info: '選定的銷售信息ㄴ',
    deal_source_asset_title: '購買資產',
    deal_total_source_amount: '總銷售數量',
    app_info_input: '輸入購買信息',
    app_amount: '購買數量',
    app_deal_price: '每單位價格',
    pay_target_amount: '付款數量',
    fee: '費用',
    fee_calc: '費用金額',
    msg_fee_calc: '減去{0',
    app_account: '購買註冊帳戶',
    app_receive_account: '選擇要接收的帳戶',
    c2c_buy_select_asset: '請選擇要購買的資產',
    go_home: '返回主目錄',
    buy_calc_spread: '購買匯率',
    sell_calc_spread: '出售匯率',
    cs_market_asset: '資產對',
    cs_market_basic_rate: '買賣基準率',
    transfer_type: '兌換類型',
    exchange_rate: '適用匯率',
    submit_transfer: '立即兌換',
    deal_source_min_amount: '最小購買量',
    closed_date: '終結日',
    no_deal: '無銷售清單',
    app_price_per_quantity: '每單位價格',
    app_fee_amount: '總計',
    select_deal_app_list: '購買選定的商品',
    no_select_deal_app_list: '此交易沒有購買記錄ㄴ',
    transfer_source_amount: '基準資產數量',
    transfer_target_amount: '相對資產數量',
    transfer_basic_rate: '適用買賣基準率',
    transfer_spread_rate: '應用點差率',
    transfer_exchange_rate: '應用匯率',
    transfer_list_detail: '兌換申請詳細信息',
    transfer_source_asset: '基準資產',
    transfer_target_asset: '相對資產',
    transfer_source_account_number: '基礎資產帳號',
    transfer_target_account_number: '相對資產帳號',
    transfer_detail_type: '交換類型',
    transfer_regdate: '申請日期',
    transfer_asset_info: '{0}至{1} {2}',
    transfer_asset_select: '請選擇要更換的資產',
    msg_transfer_buy: '用{0}進行購買',
    msg_transfer_sell: '以{0}出售',
    deal_fee_amount: '售披露方收取的費用',
  },
  wallet_page: {
    have_asset: '持有資產',
    asset_list: '資產列表',
    account_list: '帳戶列表',
    account_create: '創建帳戶',
    deposit: '存款',
    withdraw: '取款',
    deposit_list_look: '存款記錄查詢',
    deposit_look: '存款查詢',
    withdraw_list_look: '取款記錄查詢',
    withdraw_look: '提款查詢',
    account_modify: '編輯帳戶',
    deposit_apply: '申請存款',
    withdraw_apply: '取款',
    deposit_request_amount: '存款金額',
    withdraw_request_amount: '取款金額',
    withdraw_account_info: '取款賬戶信息',
    holder_name: '儲戶名',
    bank_name: '銀行',
    withdraw_bank_address: '帳號',
    withdraw_address: '資產地址',
    qr_address: '錢包地址',
    create_qr_address: '開設帳戶地址',
    account_enroll: '登錄賬戶',
    account_seq: '賬戶專號',
    account_title: '帳戶名',
    regdate: '開戶日期',
    before_regdate: '(開戶前)',
    holding_balance: '凍結金額',
    select_asset: '選擇資產',
    create: '開戶',
    deposit_list: '存款記錄',
    no_deposit_list: '沒有存款申請的詳細信息。',
    deposit_apply_detail: '存款申請詳細信息',
    asset_title: '資產名稱',
    request_amount: '請求金額',
    withdraw_list: '取款記錄',
    no_withdraw_list: '沒有提款要求。',
    withdraw_apply_detail: '取款申請詳細信息',
    withdraw_fee_total_amount: '總取款額（包含手續費）',
    net_amount: '最終金額',
    fee_type: '手續費類型',
    fee_charge_type: '手續費附加類型',
    amount_of_fee: '手續費附加額',
    create_account_address: '開戶地址',
    deposit_msg: '從錢包外面存入我的錢包{0} {0}。',
    deposit_msg_1: '一旦被批准350倍（確認）的嵌段鏈{0}的交易將反映在錢包。',
    deposit_step_1: '步驟1首先檢查ID {0}備忘錄。',
    deposit_step_1_1: '我的筆記ID {0}',
    deposit_step_1_2:
      '{0}當你的存款必須標記你自己的筆記ID。 {0}，沒有轉印筆記ID丟失。',
    deposit_step_1_3: '查看您的{0}錢包地址。',
    deposit_step_1_btn: '注身份證複印',
    deposit_step_2: '第2步：檢查你的錢包地址。',
    deposit_step_2_1: 'QR碼',
    deposit_step_2_2: '錢包地址',
    deposit_step_2_3:
      '最低存款量的<span style =“顏色：＃4a90e2”> {0} {1} </跨度>。',
    deposit_step_2_btn: '錢包複製地址',
    deposit_msg_2: '請檢查',
    deposit_msg_2_1: '這個地址都是只存。',
    deposit_msg_2_2:
      '它需要以符合完成的總時間可通過塊鏈網絡的擁塞的影響，cryptocurrency星塊鏈接擁塞的<span style ="color: #4a90e2; cursor: pointer;">此處</span>你可以檢查。',
    no_account_list: '沒有帳戶列表。',
    no_favorite_account_list: '沒有收藏夾帳戶列表。',
    input_account: '請輸入要變更的賬戶名',
  },
  my_page: {
    my_profile: '我的信息',
    user_unique_num: '會員專號',
    user_name: '用戶名',
    email_address: '電子郵件',
    register_regdate: '註冊日期',
    last_login: '上次登錄',
    auth_complete: '身份驗證完成',
    not_auth: '未認證',
    expdate: '到期日',
    act_auth: '認證',
    realname_auth: '人員身份驗證',
    email_auth: '電子郵件認證',
    otp_auth: 'OTP 認證',
    enroll: '登錄',
    security: '安全等級',
    show_security: '查看安全等級',
    auth_withdraw_address: '取款地址驗證',
    apply_list: '申請記錄',
    password_modify: '修改密碼',
    email_modify: '修改電子郵件',
    account_block: '註銷賬戶',
    placeholder_old_password: '請輸入密碼',
    placeholder_new_password: '請輸入新密碼',
    placeholder_confirm: '請再輸入一次',
    placeholder_password: '請輸入密碼',
    placeholder_email: '請輸入新的電子郵件',
    mail_cert_list: '電子郵件應用歷史',
    no_mail_list: '沒有電子郵件應用歷史。',
    nominee_detail: '被推薦者記錄',
  },
  kyc: {
    register_account: '註冊帳號',
    kyc_enroll: 'KYC 認證',
    kyc_enroll_2: 'KYC 地址證明',
    kyc_enroll_3: 'KYC 4步向上調整的原因',
    auth: '認證',
    auth_code_send: '發送驗證碼',
    auth_code: '驗證碼',
    msg_auth_code: '請在5分鐘內輸入您的驗證碼',
    type_title: '類型名稱',
    withdraw_auth: '驗證取款地址',
    withdraw_auth_tit:
      '這是為了取款而進行的取款地址驗證。請登記取款賬戶及錢包地址。',
    select_asset: '選擇資產',
    select_bank: '選擇銀行',
    holder_name: '持有人的姓名',
    birth: '出生的6位數字',
    address: '資產地址',
    withdraw_list: '取款賬戶申請記錄',
    bank_name: '銀行名稱',
    withdraw_info: '提款賬戶信息',
    withdraw_complete: '資產已被驗證。',
    regdate: '登錄日',
    delete_withdraw_address: '取款地址變更',
    delete_success_address: '撤出地址已更改。',
    kyc_cert_list: 'KYC 認證記錄',
    no_kyc_list: '沒有KYC申請歷史。',
    no_kyc_withdraw_address_list: '沒有支付賬戶的應用歷史。',
    kyc_placeholder: '請輸入。',
  },
  otp: {
    enter_verification_number: '輸入您的OTP驗證碼',
    otp_auth: 'OTP認證',
    authenticode: 'OTP密鑰',
    otp_deactivate: '停用OTP',
    msg_authenticator_installation:
      '請在智能手機或台式機上安裝“ Google Authenticator”應用',
    android: 'android ',
    or: '或 ',
    iphone_series: 'iPhone，iPad和iPod',
    windows_phone: ' Windows Phone',
    and: ', 和',
    msg_microsoft_other_systems: '其他系統，包括Microsoft Windows桌面',
    msg_key: '此密鑰',
    msg_use_loss_change: ' 寫在紙上當您丟失設備或需要更改OTP時使用。',
    msg_brcode_touch:
      '運行“ Google Authenticator”應用，然後點擊屏幕底部的<b>掃描QR條形碼</ b>。',
    msg_input_authenticode:
      '請在“身份驗證代碼”下面的字段中輸入顯示在終端屏幕上的驗證碼。',
    otp_key: 'OTP密鑰',
    otp_activate: 'OTP激活',
    otp_copy: '已復制OTP密鑰',
    otp_safe_keeping: '您是否將OTP密鑰寫在紙上並將其存儲在安全的地方？',
    yes: '是',
    otp_register: '註冊',
    otp_register_success: 'OTP註冊成功完成',
    otp_delete_success: 'OTP擦除註冊成功完成。',
    msg_click_key_copy: '單擊以復制密鑰',
    otp_login: 'OTP登錄',
  },
  security: {
    show_security: '顯示安全級別',
    grade: '等級',
    condition: '條件',
    restriction: '限制',
    no_grade: '未分級',
    no: '無',
    security_title: '受安全條件的約束',
    banner1: '可靠的安全性',
    banner2:
      '對於通過ONETETHER購買或出售，ONETETHER必須通過安全的結算和付款方案對接收ONETETHER安全數據加密，實時交易監控，買方和賣方保護政策，以及所有的付款。',
    banner_invite: 'ONETETHER還沒有賬號？',
    banner_join: '免費會員註冊',
    banner3: '如何ONETETHER是保持我們的客戶的安全',
    content1_h3: '買家保護',
    content1_text:
      '如果買方ohbaesong磨損或損壞mibaesong，ONETETHER可以彌補總付款金額，包括運費為符合條件的交易成本。*',
    content2_h3: '賣家保護',
    content2_text:
      '如果你收到一個未經授權的付款或mibaesong要求對賣方在銷售符合條件，就可以得到全額保護。*',
    content3_h3: '數據加密',
    content3_text:
      '以幫助TLS，HTTPS連接保持支付，關鍵釘扎移動應用的，符合PCI標準更安全。',
    content3_btn: 'PCI法規遵從',
    content4_h3: '防欺詐',
    content4_text:
      '所有的交易都是通過分析您的帳戶和支持，以防止欺詐行為和結算實時監控。',
    sec_h2: '檢查購買',
    sec_text:
      'ONETETHER因為監控每天24小時，一年365天，當它檢測到來自平常不同的東西聯繫買家交易要求您確認您的登錄或購買。此外ONETETHER檢查通過e-mail所有的採購和銷售。',
    wran_h2: '如果你發現一個可疑點',
    warn_step1: '報告。',
    warn_step1_text1: '確認之後的細節還沒有找到一個交易批准',
    warn_step1_text2: '報告問題>未經授權的活動報告',
    warn_step1_text3: '點擊或立即聯繫ONETETHER。',
    warn_step2: '檢查是否有其他問題。',
    warn_step2_text1:
      '查看近期交易活動和帳戶設置，以確保該額外費用或變更，也請將此信息報告。',
    warn_step3: '請更改您的密碼。',
    warn_step3_text1:
      '你可以在安全菜單上的帳戶設置。或者，如果您無法在您的帳戶登錄',
    warn_step3_text2: '登錄>登錄問題',
    warn_step3_text3: '點擊獲取復位。',
    warn_btn: '報告未經授權的交易',
    online_h2: 'ONETETHER支持安全的網上活動。',
    online_h3: '帳戶安全',
    online_text: '具有高度安全的密碼保護您的帳戶。',
    online_btn: '了解更多',
    auth_incomplete: '認證不完整',
  },
  input: {
    id: '請輸入ID',
    password: '請輸入密碼（8 ~ 32位包含特殊字元）',
    repeat_password: '請重新輸入密碼',
    user_name: '請輸入用戶名',
    email_address: '輸入E-mail地址',
  },
  oauth: {
    contact_msg: '想要訪問應用程序中的{0}的以下信息。',
    agree_msg: '{0}你是否同意訪問{1}的個人信息？',
    agree_info:
      '/儲存一段服務的用戶標識提供將被使用的信息，統計，帳戶鏈接的CS等。基本信息並提供所需的項目是必須提供使用ONETETHER服務的信息。',
    agree_request: '供品',
    agree_msg2:
      '一旦同意，這些信息將按照條款和條件以及服務的隱私政策進行管理。',
    agree: '同意',
  },
  pay_head_foot: {
    account_management: '賬戶管理',
    settlement_account_list: '結算賬戶清單',
    account_summary_views: '簡要賬戶查詢',
    fund: '資金',
    history: '帳單紀錄',
    help: '幫助',
    qa: '諮詢',
    fee: '佣金',
    secure: '安全',
    go_shop: '購物',
    my_info: '我的個人資料',
    my_page: '帳戶設置',
    out: '退出',
    in: '登錄',
    about: '公司介紹',
    blog: '博客',
    employ: '喬布斯',
    site_map: '網站地圖',
    developer: '開發人員',
    partner: '夥伴',
    privacy_state: '個人信息處理方針',
    usage: '使用條款',
    feed_back: '反饋',
    warn_to_consumer:
      '通知客戶：支付ONETETHERⓒONETETHER的預付費方式的業主不需要澳大利亞金融監管局的批准。請仔細閱讀條款和條件。',
  },
  continue: '延續',
  pay_home: {
    cocobank_title: 'ONETETHER',
    platform: '平台',
    platform_rental: '租賃平台',
    cocopay_is: 'ONETETHER是業務的增長',
    help: '幫助。',
    home_banner_1: '擴大潛在客戶群遍及世界各地，並促進支付管理，',
    home_banner_2: '經營的賣家保護*，並允許安全與全天候防欺詐監控到店。',
    home_banner_3: '你可以更容易獲得成功。',
    home_banner_warn: '*條款和條件適用於保護賣家。請參閱您的合同上的資格詳情。',
    home_banner_join: '現在加入免費。',
    home_sec1_openShop: '您可以在ONETETHER開一家店。',
    home_sec1_btn: '為了應對',
    home_sec2_h2: '請選擇您需要的付款方式。',
    home_sec2_text1: 'ONETETHER可以通過網上，手機還有電子郵件進行結算。',
    home_sec2_text2: '無論銷售給誰，ONETETHER都會幫助您更容易更安全的結算。',
    home_sec2_online_pay: '在線支付',
    home_sec2_online_text:
      '可輕鬆設置ONETETHER的付款按鈕，在收到結算款、定期結算、捐贈等時也非常方便。藉助ONETETHER Checkout，使客戶可以更輕鬆，更快捷地付款。',
    home_sec2_online_more: '查看更多有關網上支付',
    home_sec2_voice_invoice: '電子郵件發票',
    home_sec2_voice_text:
      '使用專業的免費發票進行簡單的電子郵件付款。不僅可以用于海外顧客，也可以用於沒有ONETETHER賬號的顧客。',
    home_sec2_voice_more: '查看更多有關電子郵件發票',
    home_sec2_exchange_pay: '在交易所付款',
    home_sec2_exchange_text:
      '藉助交易所上集成的錢包服務，您可以在合作夥伴公司的任何交易所進行充值和買賣幣。',
    home_sec2_exchange_more: '了解有關交易所收費的更多信息',
    home_sec2_mobile_pay: '移动付款',
    home_sec2_mobile_text:
      '該解決方案針對移動設備進行了自動優化。可以在全世界任何地方都可以通過移動網站或Android及iOS應用程序更容易地進行結算。',
    home_sec2_mobile_more: '查看更多關於移動支付',
    home_sec3_h2: '找到ONETETHER特約合作夥伴更多的工作。',
    home_sec3_global:
      'ONETETHER將與世界頂級自由職業者的網站連接更多的全球機會。',
    home_sec3_btn: '檢查自由ONETETHER',
    home_sec4_h2: '這很容易上手。',
    home_sec4_banner1: '了解你需要從ONETETHER商業中心開始一切。',
    home_sec4_banner2: '加盟商的帳戶，並確認您的電子郵件地址',
    home_sec4_banner3: '認證的銀行賬戶',
    home_sec4_banner4: '選擇一個支付解決方案',
    home_sec5_h2: '為什麼全世界那麼多的企業家信<br/>賴ONETETHER？',
    home_sec5_sub_text:
      '因為它是一個很好的選擇。 ONETETHER銷售者會給全世界200多個市場的2億名以上的顧客連接25個貨幣。',
    home_sec5_sub_text_1: '因為它是一個很好的選擇。',
    home_sec5_sub_text_2:
      'cocobank給全世界200多個市場的2億以上的顧客連接25個通貨',
    home_sec5_h3: '安全。',
    home_sec5_h3_sub1:
      '自動辨別欺詐，24小時監控交易和買賣雙方的保護程序，以保護您的業務和客戶。',
    home_sec5_h3_more: '查看更多有關網上支付',
    home_sec5_h31: '全世界都在使用。',
    home_sec5_h31_sub1:
      '任何人都不需要每次輸入信息，可以快速進行付款。您可以在203個市場中以26種貨幣通過信用卡，借記卡或ONETETHER付款。',
    home_sec5_h31_more: '查看更多有關電子郵件發票',
    home_sec5_h32: '快。',
    home_sec5_h32_sub1:
      '當客戶付款時，在大多數情況下，它會立即存入ONETETHER帳戶，可以隨時取款到銀行或付款給供應商，可以自由的在COBANK結算的地方使用。',
    home_sec5_h32_more: '查看更多有關eBay網站上出售',
    home_sec6_h2: '簡單的收費結構',
    home_sec6_sub:
      'ONETETHER會收取一定的費用，只有當銷售取得。 ONETETHER費用是根據客戶的位置和銷售金額固定。',
    home_sec6_more: '查看更多有關費用',
    home_sec7_h2: '社區為韓國銷售，CBT LAB',
    home_sec7_text1:
      '跨境貿易研究所（CBT LAB）是資助海外的電子商務ONETETHER韓國（ONETETHER韓國）商人社區啟用。',
    home_sec7_text2:
      'CBT LAB幫助東海岸業務增長全球共享信息，如最新趨勢，提示和最佳實踐。',
    home_sec7_more: '了解如何採取CBT LAB的優勢',
    home_sec8_h2: '滿足合作夥伴聯鎖ONETETHER。',
    home_sec8_text1: '需要為您的網上業務的專業幫助？',
    home_sec8_text2:
      'Web託管解決方案，購物車，電子商務解決方案，如前期工程ONETETHER合夥買了這幫助您的業務。',
    home_sec8_text3: '現在發現ONETETHER為自己的公司的合作夥伴。',
    home_sec8_more: '更多的合作夥伴',
    home_sec9_h2: '成為全球暢銷書。這將一起ONETETHER。',
    home_sec9_h2_1: '成為全球暢銷書。',
    home_sec9_h2_2: '這將一起ONETETHER。',
    home_sec9_btn: '立即註冊一個帳戶',
    home_learn_h2: '了解更多',
    home_learn_li1: '網絡支付解決方案',
    home_learn_li1_1: '網站付款標準',
    home_learn_li1_2: 'ONETETHER結帳',
    home_learn_li1_3: '在eBay上購買',
    home_learn_li1_4: '比較解決方案',
    home_learn_li2: '其他應付款',
    home_learn_li2_1: 'ONETETHER電子郵件發票',
    home_learn_li2_2: '移動商務',
    home_learn_li2_3: '業務的自動付款',
    home_learn_li2_4: 'ONETETHER對於B2B',
    home_learn_li2_5: 'ONETETHER自由職業者',
    home_learn_li3: 'ONETETHER設置和集成',
    home_learn_li3_1: 'ONETETHER商業中心',
    home_learn_li3_2: 'ONETETHER韓國商人社區（CBT LAB）',
    home_learn_li3_3: '添加ONETETHER ONETETHER到現場',
    home_learn_li3_4: '檢查出最好的指南套裝',
    home_learn_li3_5: '開發人員',
    home_learn_li3_6: '夥伴',
    home_learn_li3_7: '如何ONETETHER',
    home_learn_li4: '管理我的帳戶',
    home_learn_li4_1: 'ONETETHER商業應用',
    home_learn_li4_2: '商務帳戶設置',
    home_learn_li4_3: '賣家保護計劃',
    home_learn_li4_4: '管理客戶投訴',
    home_learn_li4_5: '了解退款（退款）',
    home_learn_li4_6: '了解帳戶限制',
    home_learn_li4_7: '詐騙防範技巧',
    home_learn_li4_8: 'PCI法規遵從',
  },
  pay_nav: {
    view_your_account: '總賬戶查詢',
    account_summary_views: '簡要賬戶查詢',
  },
  pay_login: {
    secure_sub_title: '登錄和安全性',
    secure_my_profile: '我的個人資料',
    secure_update_complete: '環境狀況和設置已經更新。',
    secrue_suggest: '每當你告訴我們你的經驗。',
    search: '取回',
    my_info: '個人信息',
    update: '更新',
    e_mail: '電子郵件',
    default: '基本信息',
    call: '電話',
    phone: '（手機）',
    pay_mobile: '移動支付',
    trading: '給予和索取',
    password: '密碼',
    change: '變化',
    secure_qa: '安全問題',
    staying: '記住我的登錄更快採購',
    edit: '彙編',
    browse_manage: '管理所選設備和對保持登錄狀態的瀏覽器。',
    account_type: '賬戶類型',
    account_delete: '註銷',
    business: '業務',
    edit_email: '編輯電子郵件地址',
    change_email: '更改電子郵件地址',
    update_email: '添加您的電子郵件',
    eamil_url: 'E-mail地址',
    update_email_url: '添加您的電子郵件地址',
    error_email: '抱歉。默認的電子郵件不能被編輯。',
    confirm_new_email: '檢查新的電子郵件地址',
    change_mail: '更改電子郵件',
    confirm: '確認',
    changing: '變化',
    deleting: '刪除',
    reaming:
      '目前有兩個與您的帳戶關聯的電子郵件地址。您可以添加更多5電子郵件。',
    qa_1: '什麼是第一次參加學校的名字？',
    qa_2: '什麼是第一只寵物的名字是什麼？',
    edit_phone: '編輯現有的電話號碼',
    korea: '韓國',
    explanation:
      '添加了數字，我確認您同意自動撥打，接聽預錄電話和文本取決於原因機關將兩個數字相加的隱私政策進行說明。標準費率付費。',
    edit_phone_num: '變更電話號碼',
    edit_password: '更改密碼',
    confirm_password: '檢查您當前密碼',
    new_passod: '新密碼',
    confirm_password_new: '確認新密碼',
    secure_question: '安全問題',
    secure_pick: '選擇題',
    secure_answer: '答案',
    edit_browse:
      '隨著ONETETHER一鍵就可以快速完成支付，而不必每次都要登錄時間英寸',
    already_log: '在登錄到計算機上。',
    off_all: 'ONETETHER一鍵關閉所有設備上的',
    support: 'PayPal致力於讓客戶100％滿意。如果您有您的帳戶有問題',
    support_center: '客戶支持',
    support_text1: '或檢查',
    support_text2: '請參考。',
    support_warn:
      '如果您取消帳戶，則無法取消您的帳戶記錄也將消失和可靠性水平。',
  },
  help: {
    support_center: '支持',
    resolution_center: '爭議解決中心',
    qa_search: '搜索常見問題解答',
    common_qa: '常問問題',
    common_qa_1: '什麼`為什麼通過“獲取鏈接基金更新您的訂單狀態後顯示錯誤消息？',
    common_qa_2: '如何從韓國ONETETHER賬戶中提取資金？',
    common_qa_3: '如何添加借記卡或信用卡帳戶ONETETHER？',
    common_qa_4: 'ONETETHER我忘記了帳戶密碼。如何重置密碼？',
    common_qa_5: '我能取消已經發出已支付金額ONETETHER？',
    common_qa_6: '我如何收到通過ONETETHER付款？',
    common_qa_7: '如何發送通過ONETETHER支付？',
    common_qa_8: '如何添加一個銀行賬戶ONETETHER帳戶？',
    common_qa_9: '如何檢查我的帳戶ONETETHER相關聯的銀行帳戶？',
    common_qa_10: '如何禁用帳戶ONETETHER限制？',
    technical_support: '訂閱技術問題和更新。',
    condition_cocopay: '查看ONETETHER狀態',
    muliple_help: '更多方式獲得幫助',
    trading_help: '為了解決這樣的問題處理',
    tex_center: '稅務中心',
    tex_help: '查找稅務表格和其他資源',
    need_help: '聯繫我們',
    help_center: '聯繫客戶支持',
    help_to_center: '聯繫客戶支持',
    prepare: '準備中',
    fast_help: '請告訴我們您的問題，使我們能更快地幫助ONETETHER。',
    my_search: '搜索我的問題',
    common_problem: '常見問題',
    login_problem: '登錄問題',
    unkown_charge: '未經授權的訪問或未知的申請報告',
    send_money: '匯款',
    get_fund: '收到錢',
    withdraw_money: '取錢',
    pay_cancel: '付款或取消訂單',
    pay_hold: '付款掛起或等待',
    refund: '退款',
    pre_pament: '預先核准付款',
    negative_balance: '負平衡',
    account_qa_1:
      '雖然它顯示為“已完成”從我的帳戶ONETETHER退出狀態，這是為什麼不包含銀行賬戶的錢？',
    account_qa_2: '什麼是我的提款ONETETHER的原因仍是“待定”狀態？',
    account_qa_3: '為什麼我撤回前？',
    item_title: '訪問密碼和帳戶',
    item_title_2: '帳戶資料＆設置',
  },
  business: {
    no_trade: '沒有可以兌換的市場',
    view_your_account: '總賬戶查詢',
    available: '可得到',
    calculate_late: '顯示最重要的CCF賬戶和現持有的所有資產',
    payment_transfe: '支付轉賬',
    exchange: '貨幣兌換',
    currency_update: '添加通話',
    update_btn: '加號按鈕',
    currency_cal: '貨幣換算',
    pay_default: '首付款',
    payment_send: '發送或請求付款',
    account_list: '帳戶列表',
    no_alias: '無別名',
    new_bank: '連接新銀行',
    card: '卡',
    new_card: '連接新卡',
    credit: '信用',
    preference_payment: '選擇您喜歡的在線支付方式。',
    payment_tip:
      '當網上購物或使用該手段商品和服務在付款。您可以在任何時候選擇在結帳時不同的付款方式。',
    payment_more: '了解您的支付偏好',
    paymnet_changes: 'ONETETHER平衡',
    debit_card: '轉賬卡',
    currency_tip:
      '如果添加的貨幣，該貨幣以後接收的所有款項將記入相應的資金。基礎貨幣被用來發送一個付款或付款請求。',
    currency_1: '澳大利亞元',
    currency_2: '瑞士法郎',
    currency_3: '捷克克朗',
    currency_4: '丹麥克朗',
    currency_5: '歐元',
    currency_6: '英鎊',
    currency_7: '港元',
    currency_8: '福林',
    currency_9: '以色列新謝克爾',
    currency_10: '墨西哥比索',
    currency_11: '挪威挪威克朗',
    currency_12: '紐元兌美元',
    currency_13: '菲律賓比索',
    currency_14: '波蘭茲羅提',
    currency_15: '俄羅斯盧布',
    currency_16: '瑞典克朗',
    currency_17: '新加坡元',
    currency_18: '銖',
    currency_19: '新台幣',
    withdraw_account: '撤回賬戶',
    exchanged: '貨幣兌換後',
    exchange_rate: '匯率',
    exchange_tip: '匯率是基於當前匯率的估計量，交換費包含在ONETETHER。',
    currency_default: '（A）的日元被設置為默認貨幣。',
    currency_default_notice: '基礎貨幣被用來發送一個付款或付款請求。',
    currency_default_notice2: '關閉通話的餘額，不顯示沒有收到任何付款的電話。',
    currency_default2: 'JPY（S），默認',
    currency_quit_jp_btn: '關閉美元',
    currency_quit_btn: '千鈞一發',
    bank_account: '帳號',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: '餘額',
    bank_account_check: '保兌行',
    bank_account_remove: '刪除銀行',
    bank_continue: '你想繼續嗎？',
    bank_tip: '與銀行待處理的交易被刪除後進行處理。',
    bank_this_delete: '刪除銀行',
    card_tip: '該ONETETHER帳戶要使用它無需花費或提款限額？',
    card_confirm: '檢查卡。',
    card_type: '類型',
    expiry_date: '終結日',
    card_adress: '帳單地址',
    card_update: '卡更新',
    card_delete: '刪除卡',
    card_this_delete: '刪除卡',
    card_tip2:
      '此付款方法目前優選的。完成後，您可以設置不同的首選付款方式。處理是與（a）中未決的未定義刪除後進行處理。',
    secure_code: '驗證碼',
  },
  shop: {
    shop_list: '商店列表',
    shop_create: '創建商店',
    shop_cre_date: '登錄日',
    shop_title: '商店名',
    shop_id: '商店ID',
    shop_state: '狀態',
    shop_work: '工作',
    shop_detail: '詳細',
    shop_retouch: '修改',
    shop_settlement: '結算賬戶列表',
    shop_history: '交易記錄',
    no_shop_list: '沒有店鋪一覽',
  },
  merchant: {
    create: '登錄商店',
    update: '登錄',
    retouch: '商店名修改',
  },
  pay_legal: {
    service_usage: 'ONETETHER服務條款',
    detail_usage:
      '這些條款和條件將適用於亞太地區，拉丁美洲和歐洲的一些國家，中東和非洲用戶。要查看條款和不同國家或地區的條件下，從下面的列表中進行選擇。',
    nation: '選擇一個國家',
    every_consumer: '所有用戶',
    service_agree: '您的服務合同ONETETHER',
    privacy_state: '隱私政策',
    purpose_policy: 'ONETETHER使用政策',
    payment_agreement: 'ONETETHER其他方式付款協議',
    sell_buy: '商家和企業',
    shop_policy: 'ONETETHER支持存儲策略',
    contract_profit: '合同以營利為目的的公司',
    billing_agreement: '結算協議',
    direct_debit_agreement: '收到ONETETHER資金和借記協議',
    additional_info: '更多信息',
    infringement: 'Somyeongseo違反政策',
    policy_update: '政策更新',
    warn1:
      '通知消費者：ONETETHER支付服務被看作是按照澳大利亞法律支付（儲值工具）的預付費方式。',
    warn2:
      'ONETETHER支付的預付方式的業主ⓒCocofx私人有限公司不需要澳大利亞金融監管局的批准。我們也鼓勵消費者（用戶）仔細閱讀這些條款和條件。',
    warn3: '本使用條款和通告的規定的條款和與特定ONETETHER服務相關的條件。',
  },
  pay_privacy: {
    effective_day: '生效日期：2019 3月28日',
    summary: '摘要',
    personal_data: '通過ONETETHER收集的個人數據',
    personal_date_cause: '理由保持您的個人資料ONETETHER',
    summary_1: '我們的用戶',
    summary_2: '網站',
    summary_3: '或訪問',
    summary_4: '服務',
    summary_5: '當使用用戶',
    summary_6: '個人資料',
    summary_7:
      '如何收集和存儲，管理和共享，解釋傳輸已經編寫了本隱私政策。訪問我們的網站或使用該服務時，該隱私政策適用於您的個人資料，其他ONETETHER',
    summary_8: '用戶',
    summary_9:
      '它並不適用於網站或不擁有在線web ONETETHER或調整，包括服務站點或服務。',
    summary2_1:
      'ONETETHER您可以訪問我們的網站或當您使用以下類型的服務收集個人信息。',
    summary2_2: '使用向上和信息',
    summary2_3:
      '當您註冊一個帳號使用ONETETHER的服務，以滿足必要的信息，以提供用戶所請求的服務來收集個人數據。',
    summary2_4:
      '根據所選擇的服務，您可以要求提供創建用戶名所需的標識信息，郵寄地址，電話號碼，電子郵件地址，帳號。',
    summary2_5: '條款你可能會問，以提供額外的個人資料，這取決於服務。',
    summary3_1: '交易經驗和信息',
    summary3_2:
      '使用ONETETHER，或者如果訪問該網站，例如服務，從賣方購買，或收到錢，或者如果處理支付或匯款給朋友和家人，收集其他交易相關的信息，以及來自ONETETHER交易信息的。其他與貿易相關的信息，包括發送或請求金錢，物品或金錢支付服務的賣家，包括有關的所有信息來完成交易的信息和設備信息的支付方式，技術數據，位置信息等。',
    summary4_1: '參與者信息',
    summary4_2:
      '當您使用或訪問網站ONETETHER服務收集的個人數據用戶提供有關參與交易的其他參與者。',
    summary4_3: '要發送或請求的錢',
    summary4_4:
      '如果您發送或請求資金通過服務ONETETHER收集您的姓名，郵寄地址，電話號碼，個人數據，如從參與者發送的錢給你的你的財務賬戶信息收錢。',
    summary4_5:
      '有關要求參與者的個人數據的範圍可能取決於用於發送或要求金錢服務。',
    summary5_1: '付款方式為其他人而不是票據或票據要求付款給其他人',
    summary5_2:
      '如果使用ONETETHER服務，讓他們付賬代他人的，或者代表他們支付賬單給其他用戶，用戶名，郵件地址，電話號碼，電子郵件地址，用戶計費，而不是賬單或他人的帳戶擁有者必須收集相關的個人資料，包括你想，而不是支付賬號。',
    summary6_1: '錢添加到您的帳戶',
    summary6_1_1: '您的帳戶',
    summary6_2:
      '為了加錢到其他帳戶的用戶帳戶或用戶可以擁有，或者如果您使用ONETETHER服務請求被加入到量在此帳戶對其他用戶的另一邊從用戶有效地處理您的請求收集信息或可以從對方收集您的信息。',
    summary6_3:
      '例如，充電或使用服務ONETETHER請求，以添加到帳戶的手機數量，你可以收集其他信息，包括個人資料，以及其他參與者的移動賬戶號碼。',
    summary7_1: '與您的朋友和聯繫人人信息',
    summary7_2:
      '當用戶在您的帳戶連接的聯繫人列表，很容易給幫助人們處理當您的朋友和聯繫人ONETETHER。這樣用戶可以使用該設備，或者建立社會媒體平台或設備ONETETHER賬戶或社交媒體之間的連接時連接到該平台更好ONETETHER服務收集和ONETETHER使用您的聯繫人列表中的信息（姓名，地址，電子郵件地址等）改善環境。',
    summary8_1: '您選擇的信息，以提供ONETETHER才能使用某些在線服務或額外服務',
    summary8_2:
      '如果請求或參加現場要求的功能或改進服務，或其他可選功能的選擇，你可以收集有關ONETETHER用戶的其他信息。',
    summary8_3:
      '如果從這些服務中用來收集信息的方法，由本隱私權政策聲明不同，另行通知期間收集的信息。',
    summary9_1: '使用“ONETETHER不付款”的服務，當用戶信息',
    summary9_2:
      '對於一些有限的服務，可能需要登錄或使用您的帳戶設置不付款。 ONETETHER將收集，所有的支付方式相關的設備信息，技術數據，位置信息需要用戶完成交易的個人資料。當您選擇帳戶所有者和非貿易支付，你可以建立並與您的帳戶關聯收集交易信息。',
    summary9_3:
      '如果用戶在不帳戶擁有者，並選擇非ONETETHER交易付款，收集和存儲您提供的所有信息的使用和依照本隱私政策的信息共享。',
    summary10_1: '從第三方獲得用戶的具體信息',
    summary10_2:
      '從第三方（如商家），數據提供者，徵信機構允許的範圍內通過法律，你可以得到的信息。',
  },
  partner: {
    be_partner: '成為ONETETHER的合作夥伴。',
    banner_text:
      '購物平台提供商，市場，還有一個計費支持運營商需要支付服務提供商可以ONETETHER的合作夥伴。',
    banner_btn: '要聯繫您的客戶經理',
    benefit: '合作夥伴有權ONETETHER好處',
    benefit_1: '整合與建設解決方案技術支持',
    benefit_2:
      '請隨時聯繫我們的支持團隊為您獲得ONETETHER集成的幫助。 ONETETHER開發者門戶還可以用來作為一種資源。',
    benefit_3: '通過營銷機會的業務增長',
    benefit_4: '以提供ONETETHER可以吸引潛在客戶的許多市場機會。',
    traction: '和牽引世界各地的付款。',
    traction1:
      'ONETETHER合作夥伴支持的創新平台，為順利解決賣家的信任ONETETHER。',
    traction_btn: '更多的合作夥伴',
    program: 'ONETETHER合作夥伴計劃是免費加入。',
    program_1: '請填寫在線表格，我們將在ONETETHER與您聯繫。',
    program_2: '請介紹業務和運行的業務解決方案。',
    program_3: '請聯繫ONETETHER討論必要的修改。',
    program_4: 'ONETETHER整合與和幫助​​確保他們收到付款ONETETHER。',
    program_btn: '要聯繫您的客戶經理',
    common_qa: '常問問題',
    common_qa1: '是否有任何廠商ONETETHER合作夥伴？',
    common_qa1_text:
      'ONETETHER合作夥伴是B2B（企業對企業）公司，為客戶提供解決方案ONETETHER。 ONETETHER正與組織，如購物車，網絡託管公司，Web開發人員，物流提供商和數字營銷公司，支付網關。',
    common_qa2: '什麼ONETETHER合作夥伴資格？',
    common_qa2_text: '請聯繫您的客戶經理',
    common_qa2_text_2: '您可以對合作夥伴的資格獲得建議。',
    common_qa3: '我們提供的ONETETHER集成支持服務？',
    common_qa3_text:
      '一旦合作夥伴計劃和ONETETHER批准加入註冊，您可以訪問有價值的集成文檔和開發者論壇。它也可以讓顧問證書集成支持。',
    common_qa4:
      '還有韓國的公司之外，我可以單獨報名參加合作夥伴計劃的每一個國家？',
    common_qa4_text:
      '這取決於您所在的國家經營業務。在ONETETHER正在部署專門的合作夥伴代表，在不同國家地區的要求。',
    common_qa4_more: '查看合作夥伴計劃提供國家',
  },
  pay_main: {
    total_product: '總產品',
    total_sum: '骨料',
    pay_this_account: '設置此帳戶作為付款方式。',
    bill_show: '所述交易信息如說明書中顯示如下。',
    banner_text: 'ONETETHER更安全',
    banner_text2: '快速付款。',
    banner_text3: '無論在哪裡購物，將讓您的金融信息安全。',
    footer_1: '條款和條件',
    footer_2: '用戶協議',
    footer_3: '隱私政策',
    footer_4: '反饋',
    footer_5:
      '通知客戶：支付ONETETHERⓒONETETHER的預付費方式的業主不需要澳大利亞金融監管局的批准。',
    footer_6: '使用條款',
    footer_7: '我們也鼓勵您仔細閱讀。',
    footer_8: '開票',
    wallet: '電子錢包管理',
    last_name: '性別',
    card_number: '卡號',
    three_number: '三位數字',
    name: '名',
    pay_cocopay: '通過ONETETHER支付',
    free_shipping: '如果ONETETHER帳戶，你可以得到免費的退貨運費，購買保護。',
    email_phone: '電子郵件或電話號碼',
    login_error: '你有麻煩了簽約？',
    pay_card: '付款卡',
    cancel_back: '取消並返回到前一頁',
  },
  site_map: {
    site_map_tip: '一個鏈接，這將幫助你探索ONETETHER帳戶。',
    map_fund: '資金',
    map_fund_1: '扣除',
    map_fund_2: '我使用的平衡能力是什麼？',
    map_fund_3: '匯款或要求付款',
    map_fund_4: '呼叫管理',
    map_fund_5: 'ONETETHER我的借記卡折扣',
    map_fund_6: '獲取ONETETHER借記卡',
    map_fund_7: 'ONETETHER信貸結算時間表',
    map_deal: '交易',
    map_deal_1: '查看所有優惠活動',
    map_deal_2: '活動的意見（包括資產和費用）',
    map_deal_3: '查看特價圖形和圖表',
    map_deal_4: '下載新政',
    map_deal_5: '響應於根據權利要求或拒付',
    map_deal_6: 'IPN（即時付款通知）歷史',
    map_profile: '我的個人資料和設置',
    map_profile_1: '商業鏡',
    map_profile_2: '電子郵件，地址，電話或密碼更新',
    map_profile_3: '銀行賬戶或卡更新',
    map_profile_4: '更新通知',
    map_profile_5: '查看賬戶限額',
    map_profile_6: '用戶管理',
    map_profile_7: '送更新偏好',
    map_support: '支持',
    map_support_1: '轉至解決衝突中心',
    map_support_2: '去支持中心',
    map_support_3: '聯繫我們',
    map_support_4: 'ONETETHER商戶費用信息',
    map_report: '報告',
    map_report_1: '報告設置，管理或下載',
    map_manage: '工具',
    map_manage_1: '查看工具',
    map_manage_2: 'ONETETHER按鈕管理',
    map_manage_3: '定期支付管理',
    map_consum: '顧客',
    map_consum_1: '查看嘉賓名單',
  },
  fee: {
    fee_tip: '簡單的收費結構',
    fee_banner_1: '一般來說，購買是免費的，可能受到貨幣兌換費。',
    fee_banner_2:
      '如果銷售不堅持使用ONETETHER月租費，或者取消費用。每個委託後才會支付。',
    fee_h2: '通常購買的是免費的。',
    fee_text1: '用於處理支付費用是由賣方支付。',
    fee_text2: '但是，您可以兌換手續費應用。',
    fee_more: '賣家收費了解更多',
    fee_text3: '對於憑發票或付款電子郵件網站銷售（國際支付標準費率適用）',
    fee_text4: '根據收到呼叫的固定費用',
    fee_text5: '交易所費用可以另外申請。',
    fee_text6: '例如，對於一個固定費用付款收據以美元為$ 0.30美元。',
  },
  dash: {
    more: '查看更多',
    withdraw_asset: '基金撤離',
    currency: '貨幣',
    quotes: '發票和會計估計',
    last_6_months: '最近6個月',
    make_invoice: '發票代',
    manage_invoice: '發票管理',
    grown_up: '請把發展業務的報價。',
    un_paid_invocie: '未付發票',
    make_quotes: '報價代',
    quotes_1: '人提出任何未付發票。',
    quotes_2: 'ONETETHER發票',
    quotes_alarm: '發送提醒',
    quotes_detail: '顯示更多',
    quotes_who: '比爾：財，所以 - 楊',
    latest_act: '近期活動',
    act: '活動',
    received: '收到付款',
    send: '從付款方式',
    act_record: '活動（包括資產和費用）',
    pay_person: '付款人',
    show_all: '查看所有',
    tell_us: '請告訴我們你的意見。',
    feed_text:
      '請花一點時間來告訴我們在這個頁面上全新設計的顯示信息，你的意見。謝謝！',
    service: '提供反饋',
    feed_text_back: '謝謝您的意見！這是我們的網站是如何有用嗎？',
    feed_placeholder:
      '請讓我知道我今天來有ONETETHER是一個更好的辦法的原因。不包括個人信息，如電子郵件或賬戶號碼。',
    feed_p:
      'ONETETHER辦公室工作人員和客人您的意見可以在內部發布，所以你可以看到它，不會留下任何個人信息。客戶服務問題，請點擊此處。 ONETETHER的',
    feed_protect: '隱私政策',
    feed_law: '法律條款',
    feed_or: '和',
    feed_need: '見',
    trade_name: '交易名稱',
    trade_id: '交易ID',
    transaction_type: '交易類型',
    trade_amount: '付款金額',
    detail_show: '看',
  },
  shop_detail: {
    detail_info: '商店詳細信息',
    api_signature: '商店簽名密鑰',
    msg_shop_create: '這家商店已被註冊。',
    msg_shop_modify: '已修改',
  },
  merchant_account: {
    create_account: '生成結算賬戶',
    enroll_account: '登錄結算賬戶',
    pls_select_account: '請選擇結算賬戶',
  },
  transaction_detail: {
    transaction_title: '交易細節',
    order_id: '車間定單號',
    pay_account_title: '付款賬戶名稱',
    pay_account_number: '支付賬號',
    pay_account_balance: '付款賬戶餘額',
    pay_account_selection: '選擇支付賬戶',
    pay_account_selection_msg: '請支付付款帳戶。',
  },
  guide: {
    guide_title_1: 'Coco Bank賬戶',
    guide_title_2: 'Coco銀行如何轉移和匯款？',
    guide_title_3: '通過Coco Bank的賬戶利用更方便和安全的服務。',
    guide_strapline_1: '①可以立即刪除的賬戶',
    guide_strapline_2: '②輕鬆打開快速賬戶簡單',
    guide_strapline_3: '隨員',
    guide_strapline_4: '匯款',
    guide_strapline_5: '可存入韓國最多的硬幣的賬戶',
    guide_strapline_6: '安全賬戶免受黑客攻擊',
    guide_strapline_7: '視覺歷史查詢和收據可用',
    guide_strapline_8: '可用作公司結算賬戶',
    guide_strapline_9: '通過賬戶快速交易C2C和B2C交易',
    guide_strapline_msg_1: 'COCO銀行的賬戶轉移不會用於轉移金錢。',
    guide_strapline_msg_3: 'Coco Bank的帳戶開放是10秒。',
    guide_strapline_msg_4: '省略複雜的過程。',
    guide_strapline_msg_5: '您只能為該資產創建帳戶名稱。',
    guide_strapline_msg_6: '通過錢包轉移',
    guide_strapline_msg_7: '使用錢包地址',
    guide_strapline_msg_8: '費用費用',
    guide_strapline_msg_9: '在Coco Bank匯款',
    guide_strapline_msg_10: '使用帳號',
    guide_strapline_msg_11: '費零',
    guide_strapline_msg_12:
      '在全球範圍內發布了許多類型的加密累積。 Coco Bank正在處理各種加密累積，以幫助客戶便利地根據這些變化。',
    guide_strapline_msg_13:
      '安全是加密包含的核心。 Coco Bank認為最重要的安全性，並且數碼工程師在每個領域擁有超過五年的經驗已經建立了安全系統。',
    guide_strapline_msg_14:
      '您可以查詢帳戶之間的傳輸。 Coco Bank的賬戶可以檢查銀行或其他銀行之間的銀行，如市場銀行。如有必要，您可以訪問該點並檢查並輸出發布歷史記錄。',
    guide_strapline_msg_15:
      'Coco Bank的賬戶與Coco Market的付款和結算賬戶相關聯。在將目標加密賬戶作為結算賬戶註冊後，您可以將在Coco Market銷售的貨物結算到密碼貨幣。',
    guide_strapline_msg_16:
      '通過錢包在個人之間的交易上發生費用和延誤。 Coco Bank提供Coco Bank Consock匯款作為解決此問題的方法。通過Coco Bank的賬戶經歷C2C和B2C交易 而無需費用和延遲。',
  },
  account_transfer: {
    transfer: '轉賬',
    transfer_list: '轉賬記錄',
    transfer_list_title: 'ONETETHER 轉賬',
    transfer_list_wallet: '其他錢包轉賬',
    msg_required_data: '請輸入所有值',
    msg_not_select_withdraw_account: '請選擇付款賬戶',
    create_transfer_title: '轉賬',
    from_account_select: '選擇支付賬戶',
    available_transfer: '轉讓金額',
    to_account_input: '輸入轉賬賬號',
    to_account_confirm: '轉賬賬戶確認',
    to_account_user_name: '轉賬會員名',
    transfer_amount: '轉賬金額',
    delete_amount: '更正',
    all_amount: '全額',
    description: '說明',
    transfer_btn: '轉賬',
    transfer_info_check: '支票轉賬請求信息',
    from_account_number: '取款賬號',
    from_asset_title: '取款資產帳戶',
    to_account_number: '轉賬賬號',
    success_transfer: '轉讓已成功處理。',
    transfer_list_detail: '轉賬記錄查詢',
    search_transfer_asset: '按資產搜索',
    search_transfer_account: '按帳戶搜索',
    reset: '初始化',
    search: '取回',
    transfer_list_detail_tit: '詳細轉賬記錄',
    no_transfer: '不得轉讓細節',
    msg_not_search_account: '是不存在的賬號或無效的輸入值',
    my_account_transfer: '我的賬戶轉賬',
    msg_pls_select_account: '選擇資產後，搜索帳戶。',
    placeholder_amount: '請輸入轉賬金額',
    not_search_user_name: '不知道用戶名',
    msg_select_asset_search: '請選擇一個帳號',
    success_fail: '傳送失敗。',
    pls_search_asset: '請搜索資產',
    pls_search_account: '請搜索賬戶',
    pls_select_asset: '請選擇一種資產。',
    not_exist_account: '資產的帳戶不存在。',
    no_inquiry_history: '沒有查詢明細',
    account_number_list_1: '無法查詢6個月前的轉賬記錄。',
    account_number_list_2: '一次最多可查詢期間為6個月。',
    account_number_list_3:
      '現轉賬結果查詢的網站是查詢ONETETHER內及加盟店轉賬結果。<br />想通過其他錢包查詢轉賬結果的人，請在上端確認[其他錢包轉賬]。',
    account_number_list_3_1:
      '現轉賬結果查詢的網站是查詢ONETETHER內及加盟店轉賬結果。<br />想通過其他錢包查詢轉賬結果的人，請在上端確認[其他錢包轉賬]。',
    today: '當日',
    one_week: '1週',
    one_month: '1個月',
    three_months: '3個月',
    six_months: '6個月',
    withdrawal_account_number: '取款賬號',
    recent_order: '最近的訂單',
    past_order: '按過去順序',
  },
  bank_service_center: {
    title: '題目',
    date: '登錄日',
    state: '狀態',
    enter_search_word: '輸入您的搜索字詞',
    list: '名單',
  },
  service_center: {
    view_all: '查看全部',
    contact_history: '諮詢記錄',
    privacy_Statement: '個人信息處理方針',
    would_you_agree: '您要同意以上內容嗎？',
    mobile_number: '手機號碼',
    target_of_inquiry: '詢問對象',
    inquiry_contents: '諮詢內容',
    please_enter_your_inquiry: '請輸入您的詢問。',
    send: '發送',
    normal_inquiries_received: '您的詢問已成功收到。',
    inquiry_history: '查詢歷史',
    pls_select_inquiry_type: '請選擇諮詢的類型',
    pls_login_to_use_inquiry: '1，登錄第一查詢。',
    non_member_login: '非會員登錄',
    contact_id: '聯繫ID',
    view_inquiry: '查看聯繫人',
    service_center: '客戶服務',
    inquiry_details: '聯繫方式',
    msg_enter_title: '請輸入標題。',
    msg_enter_your_content: '請輸入您的信息。',
    msg_pls_login: '請登錄。',
    go_back: '返回',
    re_contact: '觸點材料',
    contents: '內容',
    msg_no_inquiry_history: '沒有聯繫方式。',
    msg_require_login_additional_authentication: '您需要登錄或其他身份驗證。',
    when_you_member: '當一個成員',
    msg_inquiry_history_can_view_after_login:
      '的聯繫人詳細信息的成員可以在登錄後進行查看。',
    non_member: '當非會員',
    lookup_inquiry: '聯繫人查找',
    msg_enter_inquiry_id: '請輸入聯繫人ID。',
    msg_enter_password_when_registering_your_inquiry:
      '當你調用註冊請輸入你設置的密碼。',
    frequently_asked_questions: '常問問題',
    msg_enter_your_password: '請輸入您的密碼。',
    pls_search_fap: '請搜索問題。',
    msg_source_filename_none: '沒有附圖。',
    super_inquiry: '最佳',
  },
  modal: {
    not_seeing_day: '白天沒見',
  },
  login_guide_modal: {
    title: '說明',
    sub_title: '為了方便使用你的星座會導致系統改革的交流。',
    content:
      '[更改前]<br/>初次註冊時進行的登錄<br/><br/>[更改後]<br/>更改為當前的電話號碼或電子郵件登錄<br/> <br/>登錄直到重組系統。 ',
  },

  affiliate: {
    affiliate_occur_list: '津貼發生明細',
    affiliate_adjust_list: '津貼清算明細',
    allowance_balance_asset: '各資產津貼餘額',
    list_allowance_balance_asset: '各資產津貼餘額目錄',
    search_by_asset: '按資產搜索',
    allowance_search: '按津貼對象搜索',
    generator: '發行人',
    beneficiary: '受惠人',
    benefactor: '施惠人',
    behavior_type: '行為類型',
    target_unique_number: '目標唯一編號',
    date_of_occurrence: '發生日期',
    application_policy_name: '適用政策名',
    beneficiary_type: '受惠人 類型',
    benefactor_type: '施惠人 類型',
    target_amount: '本金對象',
    principal_amount: '本金',
    allowance: '津貼',
    allowance_assets: '津貼資產',
    allowance_amount: '津貼額',
    affiliate_log: '津貼記錄',
    allowance_settlement: '津貼結算',
    allowance_settlement_info: '津貼結算信息',
    name_asset_settled: '待結算資產名稱',
    balance_receive_payment: '待付餘額',
    select_account_settled: '選擇要結算的帳戶',
    no_affiliate_log: '沒有津貼明細',
    no_affiliate_balance: '沒有按資產分類的備抵餘額清單。',
    no_affiliate_adjust: '沒有津貼支付歷史。',
    asset_name: '資產名稱',
    asset_code: '資產代碼',
    balance: '餘額',
    cumulative_amount: '累計量',
    please_select_account: '請選擇一個帳號。',
    calculate: '計算',
    settle: '解決',
    calculate_amount: '結算金額',
    account_number: '賬號',
    registration_date: '登錄日',
    number: '號碼',
  },
  coin_name: '硬幣名稱',
  main_function: '主功能',
  disclosure_ing: '在...的過程中',
  quick_service: '快捷服務',
  new_account: '新賬戶',
  social_login: '社會登入',
  way_to_find: '位置',
  cocobank_korea_head_office: 'ONETETHER韓國總行',
  cocobank_branch_office: 'ONETETHER新沙支店',
  address_head_office: '首爾江南區彥州路528',
  address_branch_office: '首爾特別市江南區農賢路803',
  map: '地圖',
  korean_language_counseling: '韓國語諮詢',
  hours_of_business: '韓國時間10:00至19:00(銀行假期除外)',
  overseas_consultation: '海外諮詢',
  email_consultation: '郵件諮詢',
  exchange_price: '兌換/行情',
  market_price_check: '行情查詢',
  full_account_inquiry: '總賬戶查詢',
  exchange_details_check: '兌換記錄查詢',
  cryptocurrency_exchange_history: '兌換記錄',
  deposit_account_inquiry: '資金儲備賬戶查詢',
  transfer_result_check: '轉賬結果查詢',
  dormant_account_check: '休眠賬戶查詢',
  account_and_other_case_status: '檢查ONETETHER帳戶和其他案件狀態',
  account_and_other_wallet: 'ONETETHER賬戶和篷布視圖',
  account_search: 'ONETETHER賬戶查詢',
  other_wallet_search: '其他錢包轉移',
  error_remittance: '同意在ONETETHER中返回錯誤匯款',
  transfer: '轉賬',
  other_wallets_transfer: '其他錢包/轉賬結果查詢',
  other_wallets_transfer_search: '其他錢包轉賬結果查詢',
  frequently_used_accounts: '註冊/管理常用帳戶',
  new_demand_account: '新活期賬戶',
  new_installment_savings_account: '新分期儲蓄帳戶',
  new_deposit_account: '新的定期存款帳戶',
  check_account_progress_account: '查看帳戶的新帳戶進度狀態',
  download: '下载',
  withdrawal: '取款',
  Smart_window_withdrawal: '智能窗口退出',
  smart_ATM_withdrawal: '智能ATM取款',
  customer_service: '客戶服務',
  notice: '公告',
  one_one_inquiry: '1：1諮詢',
  inquiry_details: '諮詢記錄',
  frequently_asked_questions: '經常問的問題',
  server_notice: '服務器通知',

  service_hours: '客戶服務營業時間',
  all_day_long: '（可24小時諮詢)',
  online_service_hours: '在線使用ONETETHER時間',
  unusable_hours: '24小時 年中無休 (23:30 - 24:00 不可使用)',
  offline_hours: '離線使用銀行時間',
  offline_bank_hours: '(周末和节假日除外)',

  management: '管理',
  secure_management: '安全認證/管理',
  fund_limit_management: '資金限額管理',
  issue_details_check: '問題詳細信息檢查',
  part_of_news: '這是新聞的一部分。',
  part_of_notice: '這是公告的一部分。',
  full_menu: '全菜單',
  individual: '個人',
  key_coin: '將加密貨幣連接到真正貨幣ONETETHER的主要貨幣',
  limitation_info: '有關限制限額的信息，以防止損害電信財務欺詐',
  limitation_info_1:
    '由於非面對面的帳戶開設，通過自動設備和互聯網進行的提款（轉賬）限制為每天{0} CCF。',
  limitation_info_2:
    '可以向分支機構提供用於確認交易目的的客觀身份驗證數據，並且可以在“管理>安全身份驗證/管理”中取消限制。',
  limitation_info_3: '使用網上銀行時，必須註冊一個提款帳戶才能進行轉賬交易。',
  limitation_info_4: '每個加密貨幣限制只能開設5個帳戶。',
  limitation_notice: '注意',
  limitation_notice_1:
    '註冊網上銀行可以在開立存取款賬戶後，在完成畫面上聯動申請。',
  limitation_notice_2:
    '現有的網上銀行註冊客戶，請注意，只有在取款賬戶登陸區分為互聯網+分行時，才能通過網上銀行登錄取款賬戶。',
  limitation_notice_3:
    '您必須安全身份驗證，以確保您更容易向網上銀行進行轉移。認證過程後，請改善評級，並繼續進行會計系統的會計和安排。',

  new_subscription: '註冊',
  new_subscription1_1: '點擊註冊，會發放會員固有的',
  new_subscription1_2: 'ONETETHER專用賬戶及外部錢包聯動的匯款地址。',
  new_subscription2_1:
    '匯款前一定要知道！在ONETETHER專用賬戶之間轉賬，不收取任何手續費。註冊時發行的賬戶/地址只有',
  new_subscription2_2:
    '才能匯款。如果試圖將其他數字資產存入該地址，可能發生的錯誤/損失將無法恢復。確認後，通過匯款流程反映到餘額中。匯款過程會自動進行，根據網路情況所需時間會有所不同。上述地址是匯款專用地址。',
  new_subscription3_1: '會員可以',
  new_subscription3_2: '匯款。',
  new_subscription4: '您是否同意並理解以上內容？',

  created_account_number: '創建帳號',
  cocobank_exclusive_account: 'ONETETHER 專用帳號',
  depositing_external_wallet: '從外部錢包存入ONETETHER時',
  use: '使用',
  we_future: '我們的未來',
  pop_cocobank: 'ONETETHER',
  fourth_industry: '第四產業的領導者',
  oc_15: '十月15',
  officially_open: '正式開放！',
  head_branch_office: '韓國總公司（蠶室店）/第一分店（新沙店）',
  sep_15: '9月15日下午5點',
  open_popup: '打開',
  thanks_for: '謝謝您的鼓勵。',

  direct_exchange: {
    sell_buy_assets: '出售和購買的資產',
    replace_assets: '要更換的資產',
    ccm_exchange_rate: 'CCM持有優惠匯率',
    buy_sell_percent: '買-10％賣+ 10％',
    expected_property: '預期屬性',
    preferential_property: '優先資產',
  },

  event_banner: {
    clap: '請用ONETETHER的<span class="color-common">CLAP</span>保存加密貨幣',
    month_hotcoupon: '查看本月的 HOT優惠券。',
    hotcoupon_sub: '從匯率到各種會員優惠券！',
    grab_bug: '捕捉錯誤',
    grab_bug_sub: '請在1:1諮詢處留言，我們將通過抽籤贈送獎品。',
    event2_sub_title: '人生第一筆',
    event2_title: '<span style="font-weight: 700">CCM</span> 分紅',
    event2_text:
      '只要<span style="font-weight: 700">加入</span>就給<span style="font-weight: 700">分紅</span><br>只要<span style="font-weight: 700">升級</span><br><span style="font-weight: 700">手續費</span>就<span style="font-weight: 700">會降低</span><br >給很多<span style="font-weight: 700">分紅</span>的<span style="font-weight: 700">商品</span><br>與<span style="font-weight : 700">CCM</span>的<span style="font-weight: 700">首次會面</span>',
    event2_btn: '註冊',
  },
  news_lists: {
    news_list_1:
      '프라비코, iq옵션과 같은 방대한 트렌젝션을 일으키는 거래소가 될 것',
    news_list_2:
      'GCC 코인 10월 15일 포블게이트에 상장. 비트코인처럼 안정화 된 코인이 목표',
    news_list_3: '프라비코, 의료산업에 블록체인 기술 접목한다',
    news_list_4: '디파이 열풍! 그 명과 암',
    news_list_5:
      '은행을 대체할 수 있을까? 블록체인 보관과 검증은 어떻게 이루어지나',
    news_list_6: '블록체인은 식품 유통에 혁신적인 발전을 가져올 것이다',
    news_list_7: '가장 혁명적인 화폐 비트코인 탄생 배경은?',
  },
  pop_notice: {
    notice_close: '關閉',
    notice_today: '今天不看',
  },
  clap: {
    getting_started_clap: '初始設置方法',
    how_to_initialize_clap: '初始化方法',
    getting_started_ledger_live: 'Ledger Live設置法',
    install_coin_app: 'coin app 聯動',
    start_text_1:
      "1. 請使用與CLAP同封的USB連接器連接到電腦後，如顯示'Welcome'文字，就是新產品。",
    start_text_2:
      "2.請按下右鍵,當顯示'Set up as New Device'時 請同時按上端兩個按鈕。",
    start_text_3:
      "3.確認'Chose a PIN code'文字後， 會出現輸入8位pin碼的頁面，並按兩邊按鈕設置pin碼。",
    start_text_4:
      '4.pin碼設置完成後,會顯示Confirm PIN code，請按兩邊按鈕,再次輸入pin碼。',
    start_text_5:
      '5.pin碼設置完成後，按右鍵，會顯示24個句子中的第一句，請根據上邊顯示的號碼，把代碼填寫在復原卡背面。',
    start_text_6: '6.填寫完成後，請輸入與數字相符的1到24的復原代碼。',
    start_text_7:
      '7. 如顯示Press both buttons to Continue時，請按上端兩側的按鈕進行。',
    init_text_1: '1.初始化開始前,首先,請確認是否有重要復原卡和恢復碼。',
    init_text_2:
      '2.初始化方法有兩種，第一種，如果PIN code連續錯3次就會自動初始化。',
    init_text_3:
      '3.第二種，請將CLAP連接到PC，輸入PIN code解鎖，然後進行Settings > Security > Reset All。',
    init_text_4: '4.請在Cancel和Reset All中再次按Reset All進行初始化。',
    init_text_5: '5.請輸入PIN code完成初始化。',
    init_text_6: '6.初始化完成。',
    ledger_live_text_1: '1.請輸入start.ledgerwallet.com 網址。',
    ledger_live_text_2:
      '2.請在Step 1中點擊Ledger Live app，安裝適合的手機和電腦的app。',
    ledger_live_text_3: '3.顯示Welcome to Ledger Live時，請點擊Get Started進行',
    ledger_live_text_4:
      '4.會顯示四項選擇，購買CLAP進行的顧客可以選擇第一項，其他可以根據顧客的情況選擇。',
    ledger_live_text_5: '5.在完成CLAP初始設置後,請選擇第三項',
    ledger_live_text_6: '6.在三項選擇中選擇Ledger Nano S後，點擊Continue。',
    ledger_live_text_7: '7.會出現三種核對列表，可根據顧客情況設定。',
    ledger_live_text_8: '8.請確認核對列表後，按第三個Check Now。',
    ledger_live_text_9:
      '9.請連接電腦和CLAP，解除CLAP鎖定。（這是確認正品過程）',
    ledger_live_text_10:
      '10.如在第三個核對列表中正品確認(Your device is genuine)的話，請按右下角的continue。',
    ledger_live_text_11:
      '11.會出現設置密碼頁面，設不設置密碼都可以，需要設置密碼的人，輸入密碼後請按右下角的continue/要跳過的人請按skip this step。',
    ledger_live_text_12: '12.請按右下角的continue進行。',
    ledger_live_text_13: '13.Ledger Live的設置完成了。',
    coin_app_text_1:
      '1. 請打開之前設置的Ledger Live，點擊中央的Go to Manager。',
    coin_app_text_2: '2. 請將CLAP連接到PC，並輸入PIN CODE。',
    coin_app_text_3: '3. 請輸入PIN CODE後，請同時按上端兩端按鈕進行操作。',
    coin_app_text_4:
      '4. 請在下端找出顧客持有的加密貨幣，並按右側的 Install進行聯動。',
    detail_to_buy: '詳細及購買處',
    detail_content1_1:
      '拍攝是有意義的，用戶的加密產品組合配置為確保安全維護資產。',
    detail_content1_2:
      '全球金融業正在通過新技術的發現和創新迅速發展。根據這些變化，加密也改變並應用了許多全球公司一直在重視加密的價值。',
    detail_content1_3:
      '由於僅以計算機上的信息的形式使用，長期用戶對資產的安全性具有更多的煩惱。',
    detail_title_2: '拍手提供的服務是肯定的。',
    detail_content2_1:
      'Coco Bank判斷，將雲中私鑰存儲私有鍵的軟牆容易受到外部黑客，並且將發生安全問題。我們建議解決補充這些問題的求解錢包拍攝。',
    detail_content2_2:
      'CLAP最多支持八個應用程序，可以保留各種加密，如鑽頭硬幣，額頭和跳線。您還可以從外部黑客安全地保留資產，因為它不是並不總是連接到互聯網的錢包。',
    detail_title_3: '安全',
    detail_content3_1:
      '拍手是一種協作（冷錢包），與“分類帳”的合作，以及與全球加密專業安全解決方案公司的合作，解決熱牆（熱錢包）的安全問題。',
    detail_content3_2:
      'CLAP已由安全解決方案應用，該安全解決方案已由130名全球工程師構建，具有數字安全知識和體驗。我們已插入護照和信用卡使用的最新安全密碼芯片以提高安全性。',
    detail_content3_3:
      '即使您丟失了拍手，您也可以通過新的CLAP設備保留您擁有的資產。',
    detail_title_4: '方便',
    detail_content4_1: '您可以使用位於拍攝頂部的兩個按鈕輸入密鑰。',
    detail_content4_2:
      '我們支持40多個加密，包括比特幣，以太坊和XRP，並考慮用戶方便。',
    detail_title_6: '作為',
    detail_content6_1: 'A / S用於產品設備是從購買之日起的一年。',
    detail_content6_2: '如果需要A / s，請訪問COCO銀行與拍手。',
    detail_content6_3:
      '需要連接到A / S背面的序列號。 A / S不能用於破壞或刪除序列號。',
    detail_content6_4:
      '根據您的粗心和產品狀態引起的產品的產品，A / S可能無法實現。',
    detail_title_7: '注意',
    detail_content7_1:
      'Clap的在線服務與Coco Bank無關，因為它們由Ledger提供服務。',
    detail_content7_2:
      '如果您使用該產品，請注意，由由粗心（丟失，恢復和連接到受感染的PC的丟失，恢復和連接PIN碼）引起的外部黑客問題引起的外部問題不對Coco Bank負責。',
    detail_content7_3:
      '“分類賬實時”或分類賬提供的在線服務與用戶獲得的用戶無關與Coco Bank無關。',
    detail_title_8: '購買',
    detail_content8_1: 'Co.u Co.u（Cafe）：430 1樓',
    detail_title_9: 'A / S接待處',
    detail_content9_1: 'Coco Bank：首爾，江南，首爾528二樓',
    detail_content9_2:
      '請隨時與我們聯繫，與最近的Kozuko Koh，或Help@cocobank.com與我們聯繫。',
  },
}
